import {
  ICompanyValueIncreasePlans,
  IGoal,
  IGoalsAndOperationalPlans,
} from '@Domains/GoalsAndOperationalPlans';
import { IGoalsAndOperationalPlansFormValues } from './Containers/GoalAndOperationalPlansFormProvider/types';

export const mapGoalsAndOperationalPlansToFormValues = (
  data?: IGoalsAndOperationalPlans
): IGoalsAndOperationalPlansFormValues | undefined => {
  if (!data) return;

  const { companyValueIncreasePlans, ...values } = data;

  return {
    ...values,
    companyValueIncreasePlans:
      companyValueIncreasePlans &&
      mapCompanyValueIncrease(companyValueIncreasePlans),
    isAllCompletedTh: false,
    isAllCompletedEn: false,
  } as IGoalsAndOperationalPlansFormValues;
};

const mapCompanyValueIncrease = (
  companyValueIncreasePlans: ICompanyValueIncreasePlans
) => {
  const { goals = [], ...values } = companyValueIncreasePlans;
  return {
    ...values,
    valueUpPlans: goals && mapCorpValueUpPlans(goals),
  };
};

const mapCorpValueUpPlans = (valueUpPlans: Array<IGoal>) => {
  return valueUpPlans.map((plan) => {
    const { descriptionEn, descriptionTh, operationPlans, ...values } = plan;
    return {
      ...values,
      goals: operationPlans,
      significanceTh: descriptionTh,
      significanceEn: descriptionEn,
    };
  });
};
